<template>
    <div>
        <v-btn :color=color
               class="text-none"
               rounded
               depressed
               :loading=buttonLoading
               @click="onButtonClick">
            <v-icon left>
                cloud_upload
            </v-icon>
            {{ buttonText }}
        </v-btn>
        <input ref="uploader"
               class="d-none"
               type="file"
               accept="application/pdf,image/*"
               @change="onFileChanged">
    </div>
</template>

<script>
    export default {
        props: {
            defaultButtonText: { default: "Upload file" },
            selectedFileName: { default: '' },
            color: { default: "primary" },
            loading: { default: false },
            ignoredFiles: { default: null },
        },

        data() {
            return {

                // selectedFile: null,
                isSelecting: false,
            }
        },

        computed: {
            buttonText() {
                return this.selectedFileName != null ? this.selectedFileName : this.defaultButtonText
            },

            buttonLoading() {
                return this.loading || this.isSelecting
            }
        },

        methods: {
            // Quand le bouton est cliqu�
            onButtonClick() {
                this.isSelecting = true
                window.addEventListener('focus', () => {
                    this.isSelecting = false
                }, { once: true })

                this.$refs.uploader.click()
            },

            // Renvoyer le fichier s�lectionn� vers le parant
            onFileChanged(e) {

                // Split pour avoir l'extension du fichier et v�rifier qu'elle ne correspoand pas � heic
                if ((e.target.files[0] != null
                    && e.target.files[0].name.split('.').pop().toLowerCase() != this.ignoredFiles) || this.ignoredFiles == null) {
                    this.$emit('file-update', e.target.files[0])
                }else {
                    alert('format not supported')
                }
            }
        }
    }
</script>

<style scoped>
    .v-icon--left {
        margin-right: 8px;
    }
</style>